// Slice 45 — privacy formatters.

export function fmtDateMs(ms: number | null | undefined): string {
  if (!ms) return "—";
  const d = new Date(ms);
  const pad = (n: number) => (n < 10 ? `0${n}` : String(n));
  return `${d.getFullYear()}-${pad(d.getMonth() + 1)}-${pad(d.getDate())}`;
}

export type Urgency = "danger" | "warn" | "ok" | "closed";

export function deadlineUrgency(
  deadlineAt: number,
  closedAt: number | null,
  now: number = Date.now(),
): Urgency {
  if (closedAt != null) return "closed";
  const daysLeft = Math.floor((deadlineAt - now) / 86_400_000);
  if (daysLeft < 3) return "danger";
  if (daysLeft < 7) return "warn";
  return "ok";
}

export function daysLeft(deadlineAt: number, now: number = Date.now()): number {
  return Math.floor((deadlineAt - now) / 86_400_000);
}
